import { render } from "./OnThisDay.vue?vue&type=template&id=565563a5&scoped=true&ts=true"
import script from "./OnThisDay.vue?vue&type=script&lang=ts"
export * from "./OnThisDay.vue?vue&type=script&lang=ts"

import "./OnThisDay.vue?vue&type=style&index=0&id=565563a5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-565563a5"]])

export default __exports__